import React from "react"
import './printables.css'
import { get_printables } from '../../services/printables_service'
import { PageIntro } from '../Templates'


const PrintablesGridView = ({ id, title, image_src, link_url, link_text }) => {
    return (
        <React.Fragment>
            <div className="printables-grid-item-container">
                <a href={`/printables/${id}`} className="file-link">
                    <img className="single-file-view" src={image_src} />
                    <h3>{title}</h3>
                </a>
                {link_url && <a target="_blank" rel="noreferrer" href={link_url}>{link_text || link_url}</a>}
            </div>
        </React.Fragment>
    )
}


const Printables = () => {

    const printables_data = get_printables().data

    return (
        <React.Fragment>
            <h1>Printables</h1>
            <PageIntro>OTS and artists from around the world have created shareable materials to bring awareness to Palestine.</PageIntro>

            <section className="content-box content-block">
                <div className="printables-grid">
                    {printables_data.map((item, index) => (<div className="printables-grid-item" key={index}>
                        <PrintablesGridView
                            id={item.id}
                            title={item.title}
                            image_src={item.url}
                            link_url={item.link_url}
                            link_text={item.link_text} />
                    </div>))}
                </div>
            </section>
            <hr />
            <section className="printables-links content-box">
                <h3 className="printables-links">Here are some other sites where artists from other orgs have shared their work for you to view and to use in support of Palestine:</h3>
                <ul className="printables-links">
                    <li className="printables-links">
                        <a href="https://freepalestineproject.com/">The Free Palestine Project</a>
                    </li>
                    <li className="printables-links">
                        <a href="https://againstapartheid.art/art">'Against Apartheid' Art</a>
                    </li>
                    <li className="printables-links">
                        <a href="https://www.birdsofgaza.com/take-part ">Birds of Gaza</a>
                    </li>
                </ul>
            </section>
        </React.Fragment>
    )
}

export default Printables;